import api from './api';

// MIGRATION: Removed independent agent routing logic
// All agents now use unified /quotes endpoints
// Backend handles role-based filtering automatically

export const quotesService = {
  // Get all quotes
  getAll: async () => {
    const response = await api.get('/quotes');
    return response.data;
  },

  // Get single quote
  getById: async (id) => {
    const response = await api.get(`/quotes/${id}`);
    return response.data;
  },

  // Create new quote
  create: async (quoteData) => {
    const response = await api.post('/quotes', quoteData);
    return response.data;
  },

  // Update quote
  update: async (id, quoteData) => {
    const response = await api.put(`/quotes/${id}`, quoteData);
    return response.data;
  },

  // Duplicate quote
  duplicate: async (id) => {
    const response = await api.post(`/quotes/${id}/duplicate`);
    return response.data;
  },

  // Delete quote
  delete: async (id) => {
    const response = await api.delete(`/quotes/${id}`);
    return response.data;
  },

  // Send quote to client
  send: async (id, emailData) => {
    const response = await api.post(`/quotes/${id}/send`, emailData);
    return response.data;
  },

  // Convert quote to itinerary
  convertToItinerary: async (quoteId) => {
    const response = await api.post(`/itineraries/convert-quote/${quoteId}`);
    return response.data;
  },

  // Parse PDF quote using AI
  parsePDF: async (pdfFile) => {
    const formData = new FormData();
    formData.append('pdf', pdfFile);
    
    const response = await api.post('/quotes/parse-pdf', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
    return response.data;
  },

  // Move quote to different workflow stage
  moveStage: async (quoteId, stageId, reason = '') => {
    const response = await api.put(`/quotes/${quoteId}/stage`, {
      stageId,
      reason
    });
    return response.data;
  },

  // Mark quote as sent without actually sending email
  markAsSent: async (quoteId) => {
    const response = await api.put(`/quotes/${quoteId}/mark-sent`);
    return response.data;
  },

  // Conversational Quote Builder
  startConversation: async () => {
    const response = await api.post('/quotes/conversation/start');
    return response.data;
  },

  sendConversationMessage: async (sessionId, message) => {
    const response = await api.post(`/quotes/conversation/${sessionId}/message`, { message });
    return response.data;
  },

  uploadConversationFile: async (sessionId, file) => {
    const formData = new FormData();
    formData.append('file', file);
    
    const response = await api.post(`/quotes/conversation/${sessionId}/upload`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
    return response.data;
  },

  getConversation: async (sessionId) => {
    const response = await api.get(`/quotes/conversation/${sessionId}`);
    return response.data;
  },

  searchClientsForConversation: async (query = '') => {
    const response = await api.get('/quotes/conversation/clients/search', {
      params: { query }
    });
    return response.data;
  },

  finalizeConversation: async (sessionId, clientId) => {
    const response = await api.post(`/quotes/conversation/${sessionId}/finalize`, {
      clientId
    });
    return response.data;
  },

  deleteConversation: async (sessionId) => {
    const response = await api.delete(`/quotes/conversation/${sessionId}`);
    return response.data;
  }
};
